module.exports = __webpack_public_path__ + "img/card_btn_en.c95e5f80.png";